/* Stickerpack search: exact matches by default.
 * Shopify's storefront search pads keyword results with AI "related" products ("raccoon" → 841 results, 14 real).
 * Field queries skip that, so a typed search becomes (title:word OR tag:word) per word, every word required:
 * "raccoon" → title:raccoon OR tag:raccoon (14). Plurals also try the singular ("bears" → bear too).
 * main-search.liquid shows the customer's own words, falls back to the broad search (sp=related) when nothing
 * matches exactly, and links to it otherwise. sp-catalog.js uses window.spPreciseQuery for its search source. */
(() => {
  const FIELD = /\b(title|tag|product_type|vendor|sku):/i;
  const word = (w) => (/[^a-z0-9]/i.test(w) ? `"${w}"` : w);
  window.spPreciseQuery = (raw) => {
    const s = String(raw || '').trim();
    if (!s || FIELD.test(s)) return null;
    const words = s.toLowerCase().replace(/[^\p{L}\p{N}'\- ]+/gu, ' ').split(/\s+/).map((w) => w.replace(/^[-']+|[-']+$/g, '')).filter(Boolean).slice(0, 6);
    if (!words.length) return null;
    const group = (w) => {
      const forms = [w]; if (w.length > 3 && /[^s]s$/.test(w)) forms.push(w.slice(0, -1));
      return forms.flatMap((f) => [`title:${word(f)}`, `tag:${word(f)}`]).join(' OR ');
    };
    return words.length === 1 ? group(words[0]) : words.map((w) => `(${group(w)})`).join(' AND ');
  };

  // Search results page (main-search.liquid): exact = the query came from spPreciseQuery; words = the customer's words.
  // Returns { redirect } or { note } (HTML). sp=related = Shopify's broad search; sp_zero = we fell back to it.
  window.spSearchPage = ({ exact, count, words, path, search }) => {
    const params = new URLSearchParams(search), type = params.get('type') || 'product';
    const precise = window.spPreciseQuery(words);
    const related = new URLSearchParams({ q: words, type, sp: 'related' });
    if (!exact && params.get('sp') !== 'related') {
      // A plain search that didn't come through a search form (shared link, old bookmark): make it exact.
      if (!precise) return {};
      params.set('q', precise); params.set('type', 'product'); params.delete('page'); return { redirect: path + '?' + params };
    }
    if (exact && count === 0) { related.set('sp_zero', '1'); return { redirect: path + '?' + related }; }
    const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    if (exact) return { note: `Showing designs with “${esc(words)}” in the name or tags. <a href="${path}?${related}">Show related designs too</a>` };
    if (params.get('sp_zero')) return { note: `No designs match “${esc(words)}” exactly, so these are related designs.` };
    return { note: `Showing related designs for “${esc(words)}”.${precise ? ` <a href="${path}?${new URLSearchParams({ q: precise, type })}">Only exact matches</a>` : ''}` };
  };

  // Every storefront search form (header, search page, "Find it", predictive "Search for …") submits the exact query.
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement) || !/\/search\/?$/.test(new URL(form.action, location.href).pathname)) return;
    if (form.querySelector('[aria-selected="true"] a')) return; // a predictive-search result is highlighted: Dawn opens it
    const input = form.querySelector('input[name="q"]'); const q = input && window.spPreciseQuery(input.value);
    if (!q) return;
    e.preventDefault();
    // Designs only: the header and search-page forms don't send type, so Shopify also returned pages ("Lake Town") as cards.
    const params = new URLSearchParams(new FormData(form)); params.set('q', q); params.set('type', 'product'); params.delete('sp');
    location.href = new URL(form.action, location.href).pathname + '?' + params.toString();
  }, true);
})();
